import React, { useCallback } from 'react';
import { setValidPostcode } from 'models/product';

import { InformMsgSection } from '../InformMsgSection';
import { CompletedPostcode } from './CompletedPostcode';

import { PostcoderInput, Row, T8y } from 'ui';

import { ReactComponent as PinIcon } from 'assets/images/icons/pin.svg';

import style from './postcodeSection.module.scss';

export const PostcodeSection = ({
  postcode,
  setSelectingDetails,
  isMobile,
  selectingDetails,
  postcodeError,
  isPostcodeValidating,
}) => {
  const changePostCode = useCallback(
    (address = {}) => {
      setSelectingDetails((prevState) => ({
        ...prevState,
        fullAddress: address.name || '',
        postcode: address.postcode || null,
      }));
      setValidPostcode(null);
    },
    [setSelectingDetails],
  );

  return (
    <div className={style.postcodeSection}>
      {isMobile && (
        <>
          <Row justify="stretch">
            <T8y variant="t1" color="wilkoBlack" bold>
              Enter your location
            </T8y>
            <PinIcon />
          </Row>
          <T8y variant="t2v1" color="wilkoGray" mb2>
            For accurate pricing and availability
          </T8y>
        </>
      )}
      {!postcode && (
        <T8y variant="t2v1" color="wilkoBalck" boldLight mb2>
          Add your postcode
        </T8y>
      )}
      {(!isMobile || !isPostcodeValidating) && (
        <PostcoderInput
          addressByPostcode={{ postcode }}
          changeDeliveryPostcodeAddress={changePostCode}
          setEmptyAddress={changePostCode}
          completedAddress={(handleFindNewAddressClick) => (
            <CompletedPostcode
              addressByPostcode={{ postcode }}
              handleFindNewAddressClick={handleFindNewAddressClick}
              isMobile={isMobile}
            />
          )}
        />
      )}
      {isMobile && (
        <InformMsgSection
          selectingDetails={selectingDetails}
          postcodeError={postcodeError}
          isPostcodeValidating={isPostcodeValidating}
          isMobile
        />
      )}
    </div>
  );
};
